module.exports = __webpack_public_path__ + "img/personal-accident-insurance-filled.96cb91c.png";